import React, { useState } from "react";
import SubscriptionDetails from "../pages/account/SubscriptionDetails.tsx";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useLocation } from "react-router-dom";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const SubscriptionStripeWrapper = () => {
    return (
        <Elements stripe={stripePromise}>
            <SubscriptionDetails />
        </Elements>
    );
};

export default SubscriptionStripeWrapper;
